import { render, staticRenderFns } from "./UserPost.vue?vue&type=template&id=66d6805b"
import script from "./UserPost.vue?vue&type=script&lang=ts"
export * from "./UserPost.vue?vue&type=script&lang=ts"
import style0 from "./UserPost.vue?vue&type=style&index=0&id=66d6805b&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports